// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddAdvancesBatchResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_AddAdvancesBatchAdvanceRow } from './Payroll_AddAdvancesBatchAdvanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_AddAdvancesBatchResponseDados {
created_count: number
total_amount: number
advances: Payroll_AddAdvancesBatchAdvanceRow[]
errors: string[]
}

export type Payroll_AddAdvancesBatchResponse = ApiResponse<Payroll_AddAdvancesBatchResponseDados>;

registerResponseContract('Payroll_AddAdvancesBatchResponse', {
  created_count: { type: 'number',  required: true },
  total_amount:  { type: 'number',  required: true },
  advances: {
    type: 'array',
    required: true,
    items: {
      id:             { type: 'number',  required: true },
      recebimento_id: { type: 'number',  required: true },
      user_id:        { type: 'string',  required: true },
      amount:         { type: 'number',  required: true },
      despesa_id:     { type: 'number',  required: true },
    },
  },
  errors:        { type: 'array',   required: true },
})
